var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0385 5.5V3.25C16.0385 2.65326 15.8055 2.08097 15.3907 1.65901C14.976 1.23705 14.4135 1 13.8269 1H3.21154C2.625 1 2.06249 1.23705 1.64774 1.65901C1.233 2.08097 1 2.65326 1 3.25V16.75C1 17.3467 1.233 17.919 1.64774 18.341C2.06249 18.7629 2.625 19 3.21154 19H13.8269C14.4135 19 14.976 18.7629 15.3907 18.341C15.8055 17.919 16.0385 17.3467 16.0385 16.75V14.5M19.5769 5.5L24 10M24 10L19.5769 14.5M24 10H8.90625",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.8abe70801ca72960ab906887eb83838a.svg";
export { ForwardRef as ReactComponent };